import React from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { defaultAllSelection } from "services/constants";

export const CustomMultiSelection = ({
  value = [],
  onChange,
  options = [],
  placeholder = "Select company",
  error,
  helperText,
}) => {
  const handleSelection = (_, selectedOptions) => {
    let ids = selectedOptions.map((item) => item.company_id);
    if (ids.includes(defaultAllSelection)) {
      ids = [defaultAllSelection];
    } else {
      ids = ids.filter((id) => id !== defaultAllSelection);
    }

    onChange(ids);
  };

  const selectedValues =
    options?.filter((opt) => value.includes(opt.company_id)) || [];

  return (
    <Autocomplete
      multiple
      size="small"
      disableCloseOnSelect
      options={options}
      getOptionLabel={(option) => option.company_name}
      isOptionEqualToValue={(option, value) =>
        option.company_id === value.company_id
      }
      value={selectedValues}
      onChange={handleSelection}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox checked={selected} />
          {option.company_name}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={value.length === 0 ? placeholder : ""}
          error={!!error}
          helperText={helperText}
        />
      )}
    />
  );
};
